module.exports = __webpack_public_path__ + "media/img/private-venue/cheers-060adff0826946ce566065b4164a8644.svg";